export const DASHBOARD_STAT = (communityId: string) => `v1/community/${communityId}/bom-dashboard`;
export const OWNER_DASHBOARD_STAT = "v1/owner-users";
export const BOM_OWNER_DASHBOARD_STAT = (communityId: string) => `v1/community/${communityId}/bom-owner-dashboard`;
